import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Header from './components/layout/Header/Header';
import Sidebar from './components/layout/Sidebar/Sidebar';
import Connections from './pages/ConnectionsPage';
import Jobs from './pages/JobsPage';
import Repositories from './pages/RepositoriesPage';
import SummaryReport from './pages/SummaryReport';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/common/ProtectedRoute/ProtectedRoute';
import { scheduleSessionExpiry, authService } from './services/apiService';
import { useEffect } from 'react';

function AppContent() {
  const location = useLocation();

  // Rearm the proactive auto-logout timer on app load. The timer lives in
  // memory and is lost on a hard reload, but the expiry timestamp is in
  // sessionStorage so we can rebuild it. This handles the "user refreshes
  // the page mid-session and then sits idle" case.
  useEffect(() => { scheduleSessionExpiry(); }, []);

  useEffect(() => {
    const pathStorageMap = [
      { path: '/connections', key: 'connectionsState' },
      { path: '/jobs', key: 'jobsState' },
      { path: '/repositories', key: 'repoState' }
    ];

    pathStorageMap.forEach(({ path, key }) => {
      if (!location.pathname.startsWith(path)) {
        sessionStorage.removeItem(key);
      }
    });
  }, [location.pathname])

  // Login page: no header/sidebar
  if (location.pathname === '/login') {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
      </Routes>
    );
  }

  if (!authService.isAuthenticated()) {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="/login" replace state={{ from: location }} />} />
      </Routes>
    );
  }

  // Summary report: standalone full-screen view (existing behavior)
  if (location.pathname.startsWith('/summary-report')) {
    return (
      <Routes>
        <Route
          path="/summary-report/:runId?"
          element={
            <ProtectedRoute>
              <SummaryReport />
            </ProtectedRoute>
          }
        />
      </Routes>
    );
  }

  return (
    <>
      <Header />
      <Sidebar />
      <div className="main-content">
        <Routes>
          {/* <Route path="/users" element={<Users />} /> */}
          <Route
            path="/connections"
            element={
              <ProtectedRoute>
                <Connections />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <ProtectedRoute>
                <Jobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/repositories"
            element={
              <ProtectedRoute>
                <Repositories />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/connections" replace />} />
          <Route path="*" element={<Navigate to="/connections" replace />} />
        </Routes>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        closeButton={false}
        hideProgressBar={true}
      />
    </Router>
  );
}

export default App;